import {createSlice} from "@reduxjs/toolkit";


const initialState = {
    listLoading: false,
    actionsLoading: false,
    foundFailedPayments: [],
    receiptGeneratedStatus: "unknown",
    pdfReceiptStr: "",
    lastError: null
  };

  export const callTypes = {
    list: "list",
    action: "action",
    fetch: "fetch"
  };

const disputeResolutionSliceSlice = createSlice({
    name: 'reports',
    initialState:initialState,
    reducers: {
        catchError: (state, action) => {
          state.lastError = `${action.type}: ${action.payload.error}`;
          if (action.payload.callType === callTypes.list) {
            state.listLoading = false;
          } else {
            state.actionsLoading = false;
          }
        },
        startCall: (state, action) => {
          state.lastError = null;
          if (action.payload.callType === callTypes.list) {
            state.listLoading = true;
          
          } else {
            state.actionsLoading = true;
          }
        },
        failedPaymentsSearched: (state, action) => {
          state.listLoading = false;
          state.foundFailedPayments = action.payload.foundFailedPayments;
          state.error = null;

          //reset when searched again
          state.pdfReceiptStr = "";
          state.receiptGeneratedStatus = "unknown";

        },
        failedPaymentReceiptCreated: (state, action) => {
          state.actionsLoading = false;
          state.pdfReceiptStr = action.payload.pdfReceiptStr;
          state.receiptGeneratedStatus = action.payload.receiptGeneratedStatus;
          state.error = null;
        },
        failedPaymentsSearchReset: (state, action) => {
          state.foundFailedPayments = [];
          state.pdfReceiptStr = "";
          state.error = null;
          state.receiptGeneratedStatus = "unknown";
          state.actionsLoading = false;
          state.listLoading = false;
        }
      }
});


export const { actions, reducer } = disputeResolutionSliceSlice;
